export type MoreLikeThisTabValue =
  | 'more-like-this'
  | 'more-from-this-range'
  | 'people-also-viewed'

export type MoreLikeThisTabLabelKey =
  | 'more_like_this.tab_more_like_this'
  | 'more_like_this.tab_same_range'
  | 'more_like_this.tab_people_also_viewed'

export type MoreLikeThisTabConfig = {
  value: MoreLikeThisTabValue
  labelKey: MoreLikeThisTabLabelKey
}

export const MORE_LIKE_THIS_DEFAULT_TAB: MoreLikeThisTabValue = 'more-like-this'

export const moreLikeThisTabsConfig: MoreLikeThisTabConfig[] = [
  {
    value: 'more-like-this',
    labelKey: 'more_like_this.tab_more_like_this',
  },
  {
    value: 'more-from-this-range',
    labelKey: 'more_like_this.tab_same_range',
  },
  {
    value: 'people-also-viewed',
    labelKey: 'more_like_this.tab_people_also_viewed',
  },
]
